module.exports = ".f-family-en{\r\n    font-family: monospace!important;\r\n}"